import React from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import { ArrowLeft } from "lucide-react";

export default function PrivacyPage() {
  return (
    <div data-testid="privacy-page">
      <Navbar />
      <main className="bg-white">
        <div className="container-kw py-20 md:py-28 max-w-3xl">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-[color:var(--kw-muted)] hover:text-[color:var(--kw-black)] transition-colors"
          >
            <ArrowLeft className="h-4 w-4" /> Back to home
          </Link>
          <div className="eyebrow mt-8">Legal</div>
          <h1 className="mt-4 font-display font-black text-5xl md:text-6xl tracking-tight">
            Privacy Policy
          </h1>
          <p className="mt-4 text-sm text-[color:var(--kw-muted)]">
            Last updated: {new Date().toLocaleDateString("en-IN", { year: "numeric", month: "long", day: "numeric" })}
          </p>

          <div className="prose prose-neutral mt-12 space-y-8 text-[color:var(--kw-black)]">
            <section>
              <h2 className="font-display font-bold text-2xl md:text-3xl">
                1. Introduction
              </h2>
              <p className="mt-3 text-[color:var(--kw-muted)] leading-relaxed">
                King&apos;s Wake Digital Pvt. Ltd. (&quot;we&quot;,
                &quot;our&quot;, or &quot;us&quot;) respects your privacy and is
                committed to protecting the personal information you share with
                us through this website and our products.
              </p>
            </section>

            <section>
              <h2 className="font-display font-bold text-2xl md:text-3xl">
                2. Information We Collect
              </h2>
              <p className="mt-3 text-[color:var(--kw-muted)] leading-relaxed">
                We collect information you provide directly to us, such as when
                you submit a contact form (name, email address, message) or
                interact with our products. We also collect standard technical
                information (browser type, device, pages visited) to improve
                the service.
              </p>
            </section>

            <section>
              <h2 className="font-display font-bold text-2xl md:text-3xl">
                3. How We Use Your Information
              </h2>
              <ul className="mt-3 list-disc pl-5 space-y-2 text-[color:var(--kw-muted)] leading-relaxed">
                <li>To respond to your enquiries and communication.</li>
                <li>To operate, maintain, and improve our platforms.</li>
                <li>To ensure the security and integrity of our services.</li>
                <li>To comply with applicable legal obligations.</li>
              </ul>
            </section>

            <section>
              <h2 className="font-display font-bold text-2xl md:text-3xl">
                4. Sharing of Information
              </h2>
              <p className="mt-3 text-[color:var(--kw-muted)] leading-relaxed">
                We do not sell your personal information. We may share limited
                information with trusted service providers (e.g., email
                delivery) strictly to operate our services, or when required by
                law.
              </p>
            </section>

            <section>
              <h2 className="font-display font-bold text-2xl md:text-3xl">
                5. Your Rights
              </h2>
              <p className="mt-3 text-[color:var(--kw-muted)] leading-relaxed">
                You may request access to, correction of, or deletion of your
                personal information by contacting us at{" "}
                <a
                  href="mailto:team@kingswake.co.in"
                  className="underline underline-offset-4"
                >
                  team@kingswake.co.in
                </a>
                .
              </p>
            </section>

            <section>
              <h2 className="font-display font-bold text-2xl md:text-3xl">
                6. Contact
              </h2>
              <p className="mt-3 text-[color:var(--kw-muted)] leading-relaxed">
                King&apos;s Wake Digital Pvt. Ltd.
                <br />
                Punjab, India — 141412
                <br />
                Email: team@kingswake.co.in
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
